import * as React from "react";
import {AuthContext} from "../context/AuthContext.tsx";

export const useAuth = () => {
	const ctx = React.useContext(AuthContext)
	if (ctx != null) {
		return ctx
	}
	throw new Error('useAuth must be used within a AuthProvider')
}